import AccoutAndHCPtTab from './AccoutAndHCPtTab';

export default AccoutAndHCPtTab;
